import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { MessageBulkUpdate } from './message-bulk-update.interface';
import { MessageBulkUpdateService } from './message-bulk-update.service';
const service = new MessageBulkUpdateService();

export interface MessageBulkUpdateState {}

const MessageBulkUpdateStore: Module<MessageBulkUpdateState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async putMessageBulkUpdate(context, messageBulkUpdate: MessageBulkUpdate) {
         const response = await service.putMessageBulkUpdate(messageBulkUpdate);
         return response;
      },
   },
};

export default MessageBulkUpdateStore;
